import Cookies from "js-cookie";

export const getLocalStorage = (key: string) => {
  return localStorage.getItem(key);
};

export const setLocalStorage = (key: string, value: string) => {
  return localStorage.setItem(key, value);
};

export const getCookies = (key: string) => {
  return Cookies.get(key);
};

export const setCookies = (
  key: string,
  value: any,
  options?: Cookies.CookieAttributes,
) => {
  return Cookies.set(key, value, options);
};

export const removeCookies = (key: string) => {
  return Cookies.remove(key);
};

export const handleStoreCookie = (
  accessToken: string,
  refreshToken: string,
) => {
  const newExpirationTime = new Date().getTime() + 9 * 60 * 1000;

  setCookies("tokenExpirationTime", newExpirationTime.toString(), {
    expires: 30,
  });
  setCookies("accessToken", accessToken, { expires: 30 });
  setCookies("refreshToken", refreshToken, { expires: 30 });
};

export const removeAllCookies = () => {
  removeCookies("tokenExpirationTime");
  removeCookies("accessToken");
  removeCookies("refreshToken");
};

export const clearAllState = () => {
  localStorage.removeItem("selectedEvent");
  localStorage.removeItem("step");
  localStorage.removeItem("hasShownAnimation");
  localStorage.removeItem("userData");
  localStorage.removeItem("fire_number");
  localStorage.removeItem("module_badges");
};
